import { slice } from './slice'

const selectedUsersActions = slice.actions

export default selectedUsersActions
